import React from "react";

export const CopyrightWidget = props => {
    let className = 'text-small text-grey '
    if (typeof props.className !== 'undefined') {
        className += props.className;
    }
    
    return (
        <div style={{
            textAlign: props.textAlign,
            bottom: 0,
            left: 0,
            marginBottom: "48px",
            marginTop: "16px"
        }} className={className}>
            {typeof props.begin !== 'undefined'
                ? (
                    <div className="width100 flex-col-start">
                        <div>&copy; {props.begin} - {props.year} American Urological Association.</div> 
                        <div>All Rights Reserved.</div>
                    </div>
                )
                : (
                    <div className="width100 flex-col-start">
                        <div>&copy; {props.year} American Urological Association.</div> 
                        <div>All Rights Reserved.</div>
                    </div>
                )
            }
            
        </div>
    );
};
